import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/diagnostics")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/settings", replace: true });
    }
  },
  component: import.meta.env.DEV
    ? lazyRouteComponent(
        () => import("../components/settings/DiagnosticsSettings"),
        "DiagnosticsSettingsPanel",
      )
    : undefined,
});
